import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck } from 'lucide-react';
export function Pricing() {
  const handleCheckout = () => {
    try {
      if (window.fbq) {
        window.fbq('track', 'InitiateCheckout', {
          content_name: 'KIT Recruiter PRO',
          value: 19990,
          currency: 'ARS'
        });
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Pixel InitiateCheckout failed:', e);
    }
    window.location.href = 'https://checkout.sectordigital.online/cart/44092883238955:1';
  };
  const includes = [{
    text: 'Guía Principal Completa;',
    bonus: false
  }, {
    text: 'Sistema Recruiter PRO™ en 7 etapas;',
    bonus: false
  }, {
    text: 'BONUS: Planillas de Seguimiento de Candidatos;',
    bonus: true
  }, {
    text: 'BONUS: Planilla de Gestión de Búsquedas Activas.',
    bonus: true
  }];
  return <section className="py-24 bg-slate-900 text-white relative" data-id="element-92">
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-emerald-500/50 to-transparent" data-id="element-93"></div>

      <div className="max-w-5xl mx-auto px-6" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-95">
          <h2 className="text-3xl md:text-5xl font-display font-bold mb-6 max-w-3xl mx-auto leading-tight" data-id="element-96">
            TODO LO QUE NECESITÁS PARA ORDENAR TUS BÚSQUEDAS DE SELECCIÓN
          </h2>
          <p className="text-xl text-emerald-400 font-medium" data-id="element-97">
            Un solo pago. Sin suscripciones. Tuyo para siempre.
          </p>
        </motion.div>

        <motion.div id="comprar" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-white rounded-3xl overflow-hidden shadow-2xl shadow-emerald-900/50 border-4 border-emerald-500 relative scroll-mt-8" data-id="element-98">
          {/* Badge */}
          <div className="absolute top-0 right-0 bg-emerald-500 text-white font-bold px-6 py-2 rounded-bl-2xl text-sm uppercase tracking-wider" data-id="element-99">
            Oferta Especial
          </div>

          <div className="p-8 md:p-12" data-id="element-100">
            <h3 className="text-3xl font-display font-bold text-slate-900 mb-8 text-center" data-id="element-101">
              KIT RECRUITER PRO
            </h3>

            <div className="mb-8" data-id="element-102">
              <ul className="space-y-3" data-id="element-103">
                {includes.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-slate-700" data-id="element-104">
                    <Check className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-105" />
                    <span className={item.bonus ? 'font-bold text-slate-900' : ''} data-id="element-106">
                      {item.text}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center border-t border-slate-200 pt-8 mb-8" data-id="element-107">
              <div className="text-slate-400 font-medium text-xl line-through mb-2" data-id="element-108">
                $49.990 ARS
              </div>
              <div className="text-5xl md:text-6xl font-display font-bold text-slate-900 mb-4" data-id="element-109">
                $19.990 ARS
              </div>
              <p className="text-slate-500 font-medium" data-id="element-110">
                Pago único · Sin cargos ocultos
              </p>
            </div>

            <motion.button onClick={handleCheckout} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-display font-bold text-xl py-5 rounded-xl shadow-xl shadow-emerald-600/20 transition-all mb-4" data-id="element-111">
              SÍ, QUIERO EL KIT AHORA
            </motion.button>

            <div className="flex items-center justify-center text-sm text-slate-500 font-medium" data-id="element-112">
              <ShieldCheck className="w-4 h-4 mr-2 text-emerald-500" data-id="element-113" />
              Acceso inmediato · Garantía 7 días
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}